<template>
  <div class="auxiliary-information">
    <label class="auxiliary-information__title">
      {{ $t('engineering.isolation-aging.auxiliary-information') }}
      <info-badge :string-key="titleTooltip" />
    </label>
    <div class="auxiliary-information__critical-hour">
      <label class="auxiliary-information__critical-hour-title">
        {{ $t('engineering.isolation-aging.critical-hour') }}
      </label>
      <div class="auxiliary-information__critical-hour-field">
        <span class="text-wrap mr-2">
          {{ $t('fields.engineering.isolation-aging.day-before') }}
        </span>
        <span class="auxiliary-information__critical-hour-value">
           {{ lastDayAsHours }}
        </span>
      </div>
    </div>
    <div class="auxiliary-information__isolation-life-loss">
      <label class="auxiliary-information__isolation-life-loss-title">
        {{ $t('engineering.isolation-aging.isolation-life-loss') }}
      </label>
      <div class="auxiliary-information__isolation-life-loss-field">
        <span class="text-wrap mr-2">
          {{ $t('fields.engineering.isolation-aging.percentage-by-day-fixed') }}
        </span>
        <span class="auxiliary-information__isolation-life-loss-value">
          <s-number
            :fallback-value="numberFallback"
            :value="isolationLossLifePerDay.fixedDayPercentage"
          />
        </span>
      </div>
      <div class="auxiliary-information__isolation-life-loss-field">
        <span class="text-wrap mr-2">
          {{ $t('fields.engineering.isolation-aging.percentage-by-day-movable') }}
        </span>
        <span class="auxiliary-information__isolation-life-loss-value">
          <s-number
            :fallback-value="numberFallback"
            :value="isolationLossLifePerDay.movingDayPercentage"
          />
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import InfoBadge from '@/components/icon/InfoBadge';

export default {
  name: 'AuxiliaryInformation',
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    installationTimeZone: {
      type: String,
      default: '',
    },
  },
  components: {
    InfoBadge,
  },
  data: () => ({
    numberFallback: '-',
  }),
  computed: {
    titleTooltip() {
      return this.$t('messages.MI039.message', { timezone: this.installationTimeZone });
    },
    isolationLossLifePerDay() {
      return this.data.isolationLossLifePerDay || {};
    },
    lastDayAsHours() {
      const { lastDay } = this.data.criticalHour || {};
      if (lastDay == null) return '-';
      return lastDay < 10
        ? `0${lastDay}:00`
        : `${lastDay}:00`;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.auxiliary-information
  width: 100%
  display: flex
  flex-direction: column
  align-items: center
  border: 1px solid $color-border-gray
  border-radius: 3px
  padding: 8px
  &__critical-hour,
  &__isolation-life-loss
    margin-top: 5px
    padding: 5px
    width: 100%
    background-color: var(--color-background-dark)
    border: 1px solid $color-background-gray
    border-radius: 3px
    font-size: .9em
  &__critical-hour-field,
  &__isolation-life-loss-field
    display: flex
    justify-content: flex-end
    align-items: center
    text-align: right
    flex-wrap: nowrap
    margin-bottom: 8px
  &__critical-hour-value,
  &__isolation-life-loss-value
    display: inline-flex
    align-items: center
    justify-content: flex-end
    background-color: var(--color-background-light)
    opacity: .7
    padding: 3px 5px
    text-align: right
    min-width: 70px

.manage-fonts_18px
  .auxiliary-information
    &__critical-hour-value,
    &__isolation-life-loss-value
      min-width: 85px
.manage-fonts_16px
  .auxiliary-information
    &__critical-hour-value,
    &__isolation-life-loss-value
      min-width: 80px
</style>
